import React, { useRef, useState } from "react";
import "./Quiz.css";
import data from "../../assets/question.json";

// console.log(data)
const Quiz = () => {
    let [index, setIndex] = useState(0);
    let [question, setQustion] = useState(data[index]);
    let [lock, setLock] = useState(false);
    let [score, setScore] = useState(0);
    let [result, setResult] = useState(false);

    let option1 = useRef(null);
    let option2 = useRef(null);
    let option3 = useRef(null);
    let option4 = useRef(null);
    let answerArr = [option1, option2, option3, option4];
    const checkAnswer = (e, answer) => {
        if (lock == false) {
            // console.log(answer)
            if (question.right_answer === answer) {
                e.target.classList.add("correct");
                setScore((prev) => prev + 1);
            } else {
                e.target.classList.add("wrong");
            }
        }
        setLock(true);
        answerArr.map((e) => {
            //to mark on correct answer
            if (e.current.textContent === question.right_answer) {
                e.current.classList.add("correct");
            }
        });
    };
    function next() {
        if (lock === true) {
            if (index == data.length - 1) {
                setResult(true);
                return 0;
            }
            // setIndex(index+1)
            // setQustion(data[index+1])
            setIndex(++index);
            setQustion(data[index]);
            setLock(false);
            answerArr.map((op) => {
                op.current.classList.remove("correct");
                op.current.classList.remove("wrong");
                return null;
            });
        }
    }
    function reset() {
        setIndex(0);
        setQustion(data[0]);
        setScore(0);
        setLock(false);
        setResult(false);
    }

    return (
        <div className="container">
            <h1>Quiz App</h1>
            <hr />
            {result ? (
                <>
                    <h2>
                        Your Score is {score} from {data.length}
                    </h2>
                    <button onClick={reset}>Reset</button>
                </>
            ) : (
                <>
                    {" "}
                    <h2>
                        {index + 1}. {data[index].title}
                    </h2>
                    <ul>
                        <li
                            ref={option1}
                            onClick={(e) =>
                                checkAnswer(e, data[index].answer_1)
                            }>
                            {data[index].answer_1}
                        </li>
                        <li
                            ref={option2}
                            onClick={(e) =>
                                checkAnswer(e, data[index].answer_2)
                            }>
                            {data[index].answer_2}
                        </li>
                        <li
                            ref={option3}
                            onClick={(e) =>
                                checkAnswer(e, data[index].answer_3)
                            }>
                            {data[index].answer_3}
                        </li>
                        <li
                            ref={option4}
                            onClick={(e) =>
                                checkAnswer(e, data[index].answer_4)
                            }>
                            {data[index].answer_4}
                        </li>
                    </ul>
                    <button onClick={next}>Next</button>
                    <div className="index">
                        {index + 1} of {data.length} questions
                    </div>
                </>
            )}
        </div>
    );
};

export default Quiz;
